<template>
  <section class="register-two-section">
    <div class="display-picture-container">
      <div class="display-picture">
        <img src="" alt="" />
        <b-form-file
          id="dp-register"
          v-model="file"
          accept="image/*"
          class="mt-3"
          plain
        ></b-form-file>
        <label for="dp-register" class="edit-overlay hover">
          <font-awesome-icon icon="camera"></font-awesome-icon>
          <span>Add your photo</span>
        </label>
      </div>
    </div>
    <h4 class="heading squiggly-line-color line-center">
      Your account is created, please fill the below details to serve you
      better.
    </h4>
    <h5 class="form-head">Which class you are in</h5>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-form-group label="" class="radio-group">
        <!--        added selected class when radio button selected-->
        <b-form-radio-group
          id="radio-group-1"
          v-model="selected"
          :options="options"
          name="radio-options"
        ></b-form-radio-group>
      </b-form-group>
      <b-row>
        <b-col cols="6">
          <v-select
            placeholder="Select your syllabus"
            class="my-5"
            label="gateway_name"
            :options="syllabus"
            v-model="selectedOption"
          />
        </b-col>
        <b-col cols="6">
          <v-select
            placeholder="Select your location"
            class="my-5"
            label="gateway_name"
            :options="location"
            v-model="selectedOption"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <h5 class="form-head">Enter your interests</h5>
          <p class="text-center">
            <strong>Example</strong> : Music, drawing, research, Acting
          </p>
        </b-col>
        <b-col cols="12" class="pt-3 pb-5">
          <multiselect
            v-model="value"
            :options="interests"
            :multiple="true"
            placeholder="Your interests"
            :taggable="true"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
          >
            <template slot="caret">
              <div class="multiselect-caret">
                <font-awesome-icon icon="plus-square"></font-awesome-icon>
              </div>
            </template>
          </multiselect>
        </b-col>
      </b-row>
      <div class="form-bottom">
        <b-button size="lg" pill variant="primary">
          <span>Complete your profile</span>
          <font-awesome-icon icon="arrow-right" size="xs" />
        </b-button>
        <b-button type="reset" variant="link">Skip for now</b-button>
      </div>
    </b-form>
  </section>
</template>

<script>
export default {
  name: "RegisterStepTwo",
  data() {
    return {
      file: null,
      syllabus: ["Kerala", "CBSE", "ICSE", "IBO"],
      location: ["Alappuzha", "Kottayam"],
      form: {
        email: "",
        name: "",
        food: null,
        checked: []
      },
      selected: "first",
      options: [
        { text: "5th", value: "1" },
        { text: "6th", value: "2" },
        { text: "7th", value: "3" },
        { text: "8th", value: "4" },
        { text: "9th", value: "5" },
        { text: "10th", value: "6" },
        { text: "11th", value: "7" },
        { text: "12th", value: "8" }
      ],
      interests: ["Music", "Painting", "Research"],
      value: null,
      show: true
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style scoped></style>
